import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _isEmpty from 'lodash/isEmpty';
import _map from 'lodash/map';
import _isNil from 'lodash/isNil';
import PropTypes from 'prop-types';
// Models
import mAsync from 'models/async';
import mDevice from 'models/device';
// Custom
import { deviceDataShape } from 'constants/PropTypesShapes';
import InformationItem from 'components/items/InformationItem';
import { defaultIcon } from 'utils/Tools';

const deviceStatusDetail = ({
  item, status, statusText, label, deprecated,
}) => {
  const statusIcon = mAsync.statusIcon(status);
  return {
    key: item,
    icon: statusIcon.icon,
    iconColor: statusIcon.color,
    label,
    value: <LocalizedMessage id={statusText} />,
    deprecated,
  };
};

const DeviceAsyncStatusItem = ({
  device, withDetails, withLoader, light,
  ...props
}) => {
  let globalStatus;
  let globalStatusIcon = defaultIcon;
  let asyncDetails;
  const loading = (device && !_isNil(device.syncLoading)) ? device.syncLoading : true;

  if (device && device.sync_status) {
    globalStatus = mAsync.statusFromBool(mDevice.synchronized(device));
    globalStatusIcon = mAsync.statusIcon(globalStatus);
    asyncDetails = _map(mDevice.syncStatusToArray(device), ({ item, sync, deprecated }) => {
      const status = mAsync.statusFromBool(sync);
      const statusText = `syncStatus.${status}`;
      const label = <LocalizedMessage id={`field.${item}`} />;
      return {
        item, status, statusText, label, deprecated,
      };
    });
  }

  return (
    <InformationItem
      light={light}
      loading={withLoader && loading}
      icon={(!withLoader && loading) ? 'unknown' : globalStatusIcon.icon}
      iconColor={globalStatusIcon.color}
      label={<LocalizedMessage id="field.syncStatus" />}
      value={globalStatus ? <LocalizedMessage id={`syncStatus.${globalStatus}`} /> : null}
      gender="male"
      nestedItems={(withDetails && !_isEmpty(asyncDetails)) ? _map(asyncDetails, deviceStatusDetail) : null}
      {...props}
    />
  );
};

DeviceAsyncStatusItem.propTypes = {
  device: deviceDataShape,
  withDetails: PropTypes.bool,
  withLoader: PropTypes.bool,
  light: PropTypes.bool,
};

DeviceAsyncStatusItem.defaultProps = {
  device: null,
  withDetails: true,
  withLoader: true,
  light: false,
};

module.exports = DeviceAsyncStatusItem;



// WEBPACK FOOTER //
// ./routes/app/routes/devices/assets/main/DeviceAsyncStatusItem.js